import script from "./BlockEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockEditor.vue?vue&type=script&setup=true&lang=ts"

import "./BlockEditor.vue?vue&type=style&index=0&id=32de7433&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32de7433"]])

export default __exports__